module.exports = __webpack_public_path__ + "img/prizeRanking1.82343505.png";